import styled from '@emotion/styled/macro';

export const ShareDesktopWrapper = styled.div`
    display: flex;
    height: 40px;
    margin: 0 auto;
    justify-content: center;
`;

export const IconRow = styled.div`
    display: flex;
    width: 100%;
`;

export const ShareText = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    background-color: ${props => props.theme.colours.background.green};
    color: ${props => props.theme.colours.textWhite};
    font-size: ${props => props.theme.fontSize.medium};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    border-radius: 6px 0 0 6px;
`;

export const FacebookIcon = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    background-color: ${props => props.theme.colours.share.facebook};
`;

export const XIcon = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    background-color: ${props => props.theme.colours.share.x};
`;

export const WhatsappIcon = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    background-color: ${props => props.theme.colours.share.whatsapp};
`;

export const EmailIcon = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    background-color: ${props => props.theme.colours.share.email};
`;

export const CopyIcon = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    border-radius: 0 6px 6px 0;
    background-color: ${props => props.theme.colours.share.copyLink};
    cursor: pointer;
`;

export const IconImage = styled.img`
    width: 20px;
`;
